import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VgPosterComponent } from './VgPoster.Component';

const components = [
	VgPosterComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule
	]
})
export class VgPosterModule {}
